import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import { setContext } from 'apollo-link-context';
// import store from './store/index';

import appConfig from './utils/app-config';

// Install the vue plugin
Vue.use(VueApollo);

// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token';

// Http endpoint
const httpEndpoint = appConfig.VUE_APP_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4001/graphql';

const authLink = setContext(async (_, { headers }) => {
  const sessionKicker = Vue.prototype.$euiSessionKicker;

  if (!sessionKicker) return headers;

  sessionKicker.resetTimer();

  return headers;
});

// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'));

Vue.prototype.$filesRoot = filesRoot;

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  wsEndpoint: null,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,
  link: authLink

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: authLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
};

const boomiAuthLink = setContext(async (_, { headers }) => {
  const sessionKicker = Vue.prototype.$euiSessionKicker;
  const cluster = appConfig.VUE_APP_GRAPHQL_CLUSTER || process.env.VUE_APP_GRAPHQL_CLUSTER;

  headers = {
    ...headers,
    'x-api-key': appConfig.VUE_APP_GRAPHQL_BOOMI_KEY || process.env.VUE_APP_GRAPHQL_BOOMI_KEY,
    ...(cluster && { cluster })
  };

  if (!sessionKicker) return { headers };

  sessionKicker.resetTimer();

  return { headers };
});

// Call this in the Vue app file
export function createProvider(options = {}) {
  // Create apollo client
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options
  });
  apolloClient.wsClient = wsClient;

  const boomiOptions = {
    httpEndpoint: appConfig.VUE_APP_GRAPHQL_BOOMI || process.env.VUE_APP_GRAPHQL_BOOMI,
    // token: process.env.VUE_APP_GRAPHQL_BOOMI_KEY || appConfig.VUE_APP_GRAPHQL_BOOMI_KEY,
    // tokenName: 'x-api-key'
    link: boomiAuthLink
  };

  const { apolloClient: boomiClient, wsClient: boomiWsClient } = createApolloClient({
    ...defaultOptions,
    ...boomiOptions
  });
  boomiClient.wsClient = boomiWsClient;

  // Create vue apollo provider
  return new VueApollo({
    clients: {
      apolloClient,
      boomiClient
    },
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      }
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
    }
  });
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token);
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    //await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message);
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN);
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    //await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
  }
}
